<template>
    <div class="user-block sign-in">
        <template v-if="role == ''">
            <a href="/authorization">
                <div class="sign-in__button">Вход / Регистрация</div>
            </a>
        </template>

        <template v-else>
            <div class="user-block__account" v-on:click.stop="account_menu_drop_toggle()">
                <button class="user-block__account-button">{{ this.name + this.patronymic }}</button>
                <div v-if="isDropdownVisible" class="user-block__account-dropdown">
                    <template v-if="isOwner || isDispatcher">
                        <a href="/new_orders" class="user-block__account-dropdown-link">
                            <img src="@/assets/IMGS/SVG/icon-bell.svg" alt="new orders" />
                            <span>Новые заказы</span>
                        </a>
                        <a href="/order_history" class="user-block__account-dropdown-link">
                            <img src="@/assets/IMGS/SVG/icon-journal.svg" alt="history" />
                            <span>История заказов</span>
                        </a>
                    </template>

                    <a href="/order" class="user-block__account-dropdown-link">
                        <img src="@/assets/IMGS/SVG/icon-plus.svg" alt="new" />
                        <span>Заказать</span>
                    </a>

                    <a href="/account" class="user-block__account-dropdown-link">
                        <img src="@/assets/IMGS/SVG/icon-car.svg" alt="my account" />
                        <span>Мой Medmobil</span>
                    </a>
                    <a href="/my_orders" class="user-block__account-dropdown-link">
                        <img src="@/assets/IMGS/SVG/icon-cart.svg" alt="my orders" />
                        <span>Мои заказы</span>
                    </a>
                    <a href="/account?redirect=settings" class="user-block__account-dropdown-link">
                        <img src="@/assets/IMGS/SVG/icon-settings.svg" alt="settings" />
                        <span>Настройки</span>
                    </a>
                    <a href="/" id="exit" v-on:click="logout_click($event)" class="user-block__account-dropdown-link">
                        <img src="@/assets/IMGS/SVG/icon-exit.svg" alt="exit" />
                        <span>Выйти</span>
                    </a>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import $ from 'jquery';
import { useCookies } from 'vue3-cookies';

export default {
    name: 'UserBlock',
    data: function () {
        return {
            name: '',
            patronymic: '',
            role: '',
            isDropdownVisible: false,
        };
    },

    setup() {
        const { cookies } = useCookies();
        return { cookies };
    },

    computed: {
        isOwner() {
            return this.getCookie('role') == 'Owner';
        },

        isDispatcher() {
            return this.getCookie('role') == 'Dispatcher';
        },

        isAdministrator() {
            return this.getCookie('role') == 'Administrator';
        },
    },

    created() {
        var vm = this;
        const sessionStorage = window.sessionStorage;

        if (vm.getCookie('role')) {
            var storageName = JSON.parse(sessionStorage.getItem('name&patronymic'));
            if (storageName == null) {
                $.ajax({
                    type: 'GET',
                    url: global.BACKEND_URL + `/account`,
                    xhrFields: { withCredentials: true },
                    success: function (data) {
                        if (data['name']) {
                            vm.name = data['name'][0];
                        } else {
                            vm.name = '';
                        }
                        if (data['patronymic']) {
                            vm.patronymic = data['patronymic'][0];
                        } else {
                            vm.patronymic = '';
                        }
                        var dataToSave = {
                            name: vm.name,
                            patronymic: vm.patronymic,
                        };
                        sessionStorage.setItem('name&patronymic', JSON.stringify(dataToSave));
                    },
                    error: function (data) {
                        console.log('Not success :( #' + data);
                    },
                    dataType: 'json',
                    contentType: 'application/json',
                });
            } else {
                vm.name = storageName['name'];
                vm.patronymic = storageName['patronymic'];
            }
        } else {
            sessionStorage.setItem('name&patronymic', 'null');
        }
    },
    mounted() {
        // redirect if token invalid
        const url_params = new URLSearchParams(window.location.search);
        const force_refresh_token = url_params.get('refresh_token');
        if (this.getCookie('mtu_refresh_token') || force_refresh_token == 'true') {
            var refresh = {
                refresh_token: this.getCookie('mtu_refresh_token'),
            };
            var formData = JSON.stringify(refresh);
            $.ajax({
                type: 'POST',
                url: global.BACKEND_URL + '/api/refresh',
                data: formData,
                success: function () {},
                error: function () {
                    document.cookie = 'mtu_refresh_token=; path=/;';
                    document.cookie = 'role=; path=/;';
                    document.location = '/';
                },
                dataType: 'json',
                contentType: 'application/json',
            }).done(function (data) {
                document.cookie = 'mtu_refresh_token=' + data['refreshToken'] + '; path=/;';
                document.cookie = 'role=' + data['role'] + '; path=/;';
                // document.location = '/account';
                if (force_refresh_token == 'true') document.location = window.location.href.split('?')[0];
            });
        } else {
            document.cookie = 'mtu_refresh_token=; path=/;';
            document.cookie = 'role=; path=/;';
        }

        this.role = this.getCookie('role') != null && this.getCookie('role') != '';
    },

    methods: {
        getCookie(val) {
            return this.cookies.get(val);
        },
        account_menu_drop_toggle() {
            this.isDropdownVisible = !this.isDropdownVisible;
        },
        logout_click(e) {
            e.preventDefault();
            var refresh = {
                refresh_token: this.getCookie('mtu_refresh_token'),
            };
            var formData = JSON.stringify(refresh);
            $.ajax({
                type: 'POST',
                url: global.BACKEND_URL + '/api/logout',
                data: formData,
                success: function () {},
                error: function () {
                    console.log('Logout not worked');
                    document.location = '/';
                },
                dataType: 'json',
                contentType: 'application/json',
            }).done(function () {
                document.location = '/authorization';
            });
            document.cookie = 'mtu_refresh_token=; path=/;';
            document.cookie = 'role=; path=/;';
        },
    },
};
</script>

<style lang="scss">
/* user-block */
.sign-in {
    position: relative;
}

.sign-in__button {
    font-size: 12px;
    font-weight: 600;
}

.sign-in__button,
.sign-in__button:visited {
    color: #575757;
}

.user-block__account {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    display: inline-block;
    cursor: pointer;
}

.user-block__account-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 26px;
    height: 26px;
    border-radius: 100%;
    background: #e8e8e8;
    border: 1px solid #e8e8e8;
    transition: 0.25s;
    font-size: 12px;
    text-transform: uppercase;
}

.user-block__account-button:hover {
    color: #0eccaa;
    border: 1px solid #0eccaa !important;
    background: #eee !important;
    transition: 0.25s;
}

.user-block__account-dropdown {
    position: absolute;
    padding: 10px;
    background: #fff;
    margin-top: 10px;
    min-width: 220px;
    border: 1px solid #0eccaa;
    box-shadow: 5px 25px 50px 0 rgba(14, 204, 170, 0.1);
    left: auto;
    right: 0;
    z-index: 1;
}

.user-block__account-dropdown--visible {
    display: block;
}

.user-block__account-dropdown-link {
    display: flex;
    align-items: center;
    gap: 18px;
    padding: 12px 16px;
    font-size: 18px;
    white-space: nowrap;
    color: #6e7675;
    transition: all 0.5s ease;
    text-decoration: none;
}

.user-block__account-dropdown-link:hover {
    background-color: rgba(14, 204, 169, 0.082);
    color: #0eccaa;
}

</style>
